/**
 * 图片精灵非动态图片 支持层级
 */
import fvSubassembly from "../fvSubassembly"
export default class fvPictureObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        //是否启用边框
        this.isBorder = this.Border || 0;
        //线宽
        this.borderLineWidth = this.LineWidth || 1;

        //旋转角度
        this.pictureRotate = this.Rotate || 0;
        //判断旋转一次
        this.isRotate = this.Rotate || false;
        //透明度
        this.hyalineValue = 1;
        //是否启用透明背景色
        this.isHyaline = false;
        //透明背景色
        this.HyalineColor = '';
        //通过全局缓存中加载图片，加载完毕后动态生成ondraw方法，在这之前，走父类
        this.create();

        var fileName = this.system.$.getResource(this.fileName);
        if (fileName) {
            var arr = this.src.split("/");
            arr[arr.length - 1] = fileName
            this.src = arr.join("/");
        }
        this.system.$.getImgCache(this.src).then((img) => {
            this.img = img;
            callback(this);
        }, ((img) => {
            this.img = img;
            callback(this);
        }));
        this.pictureFun();
        this.createSucss();
        this.canvasDom;
        this.isNum=1;
        // this.isHide = true;
        // if(this.animation.fvHide){
        //     this.isHide = false;
        // }
    }
    updataPic() {
        var fileName = this.system.$.getResource(this.fileName);
        if (fileName) {
            var arr = this.src.split("/");
            arr[arr.length - 1] = fileName
            this.src = arr.join("/");
        }
        this.system.$.getImgCache(this.src).then((img) => {
            this.img = img;
        }, ((img) => {
            this.img = img;
        }));
    }
    onDraw(canvas, reDraw) {
        this.canvasDom=canvas;
        // this.setCanvas(canvas)
        // if(!this.isHide) return;
        if(!this.fcHide) return;
        this.formatRect();
        this.updataPic();
        canvas.save();
        this.executePreAnimation(canvas);
        if(this.isNum==0){
            let canvas=this.canvasDom;
            canvas.fillStyle = "rgba(204, 191, 191,.5)";
            canvas.fillRect(this.x, this.y, this.width, this.height);
        }

        //判断是否加边框
        if (this.isBorder !== 0) {
            this.setBorder(canvas);
        }
        this.borderWidth = this.borderLineWidth;
        //判断是否设置透明背景色
        if (this.isHyaline) {
            canvas.globalAlpha = this.hyalineValue;
            canvas.fillStyle = this.HyalineColor;
            canvas.fillRect(this.x, this.y, this.width, this.height);
        }

        //判断是否旋转
        if (this.isRotate) {
            if (reDraw) {
                return;
            }
            //计算旋转中心点
            var px = parseFloat(this.cx);
            var py = parseFloat(this.cy);

            var cx = parseFloat(px + (this.width / 2));
            var cy = parseFloat(py + (this.height / 2));
            //旋转
            canvas.save();
            canvas.translate(cx, cy);
            // 旋转度数 * Math.PI/180
            canvas.rotate(this.pictureRotate * Math.PI / 180);
            canvas.translate(-cx, -cy);
            canvas.drawImage(this.img, this.cx, this.cy, this.width, this.height);

        } else if (this.img) {
            //自定义位置
            if(this.parent.type == "group"){
                this.cx = parseFloat(this.x + this.parent.x);
                this.cy = parseFloat(this.y + this.parent.y);
            }else{
                this.cx = parseFloat(this.x);
                this.cy = parseFloat(this.y);
            }
            if (this.isBorder !== 0) {
                canvas.drawImage(this.img, this.cx, this.cy, this.width-this.borderWidth, this.height-this.borderWidth);
            }else{
                canvas.drawImage(this.img, this.cx, this.cy, this.width, this.height);
            }
        } else {
            console.warn("未找到图片:" + this.src);
        }
        this.executePosAnimation(canvas);
        canvas.restore();
        
    }
    Enable(isEnable){
        this.isNum=isEnable;
    }
    //设置边框
    setBorder(canvas) {
        canvas.beginPath();
        canvas.lineWidth = this.borderLineWidth;
        canvas.rect(this.cx, this.cy, this.width, this.height);
        canvas.stroke();

    }
    pictureFun() {
        //监听设置边框
        Object.defineProperty(this, "Border", {
            set: function (value) {
                if (value == 0) {
                    this.isBorder = value;
                } else {
                    this.isBorder = value;
                }

            },
            get: function () {
                return this.isBorder;
            }
        });
        //监听边框宽度设置
        Object.defineProperty(this, "LineWidth", {
            set: function (value) {
                this.borderLineWidth = value;


            }
        })
        //设置路径
        Object.defineProperty(this, "Path", {
            set: function (value) {
                this.img.src = "src/New App1/img/" + value;
            },
            get: function () {
                return this.img.src;
            }
        })
        //设置旋转
        Object.defineProperty(this, "Rotate", {
            set: function (value) {
                this.isRotate = true;
                this.pictureRotate = value;
            },
            get: function () {
                return this.pictureRotate;
            }
        })
        //设置透明度
        Object.defineProperty(this, "Transparency", {
            set: function (value) {
                this.hyalineValue = value / 255;
            },
            get: function () {
                return this.hyalineValue;
            }
        })
        //设置透明背景色
        Object.defineProperty(this, "TransparencyBackColor", {
            set: function (value) {
                this.isHyaline = true;
                this.HyalineColor = value;
            },
            get: function () {
                return this.HyalineColor;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvPictureObj.js